<template>
  <custom-dayPlane
    title="总电能耗占比"
    :iconImg="require('@/assets/public/percent.png')"
    @changeDay="changeDay"
  >
    <div class="ele-content">
      <div class="left-chart">
        <div class="chart-name">
          <div class="num">{{ eleTotalDataNum }}</div>
          <div class="text">({{ powerUnit }})</div>
        </div>
        <chart-base :options="options"></chart-base>
      </div>
      <div class="right-per">
        <div
          class="per-item"
          v-for="item in powerData"
          :style="`border-bottom:1px solid ${item.lineColor}`"
        >
          <div class="icon" :class="item.color"></div>
          <div class="per-num">{{ item.num }}</div>
          <div class="per-name">{{ item.name }}</div>
          <div class="per-line"></div>
          <div class="per-unit">{{ item.unit }}</div>
        </div>
      </div>
    </div>
  </custom-dayPlane>
</template>

<script>
export default {
  props: {
    percent: {},
  },
  data() {
    return {
      timeValue: "day",
      powerArray: [],
      map: {
        day: "当日",
        month: "当月",
        year: "当年",
      },
      options: {},
      powerData: [
        {
          key: "lighting",
          color: "icon1",
          lineColor: "#22FCD5",
          num: "0%",
          name: "照明电",
          unit: "0kWh",
        },
        {
          key: "power",
          color: "icon2",
          lineColor: "#2D82FF",
          num: "0%",
          name: "动力电",
          unit: "0kWh",
        },
        {
          key: "air",
          color: "icon3",
          lineColor: "#FFB0AB",
          num: "0%",
          name: "空调电",
          unit: "0kWh",
        },
        {
          key: "other",
          color: "icon4",
          lineColor: "#B98EFF",
          num: "0%",
          name: "其他",
          unit: "0kWh",
        },
      ],
    };
  },
  watch: {
    percent() {
      this.getNum();
      if (this.powerArray.length != 0) {
        this.powerArray = [];
      }
      this.loadOptions();
      // this.loadOptions();
    },
    timeValue() {
      this.getNum();
      this.loadOptions();
    },
  },
  computed: {
    eleTotalDataNum() {
      if (this.percent) {
        if (
          this.timeValue != "day" ||
          this.percent?.[this.timeValue]?.total > 100000
        ) {
          return (this.percent?.[this.timeValue]?.total / 1000).toFixed(2);
        } else {
          return this.percent?.[this.timeValue]?.total;
        }
      } else {
        return "";
      }
    },
    powerUnit() {
      if (this.timeValue != "day") {
        return "mWh";
      } else {
        if (this.percent?.[this.timeValue]?.total > 100000) {
          return "mWh";
        } else {
          return "kWh";
        }
      }
    },
  },
  methods: {
    changeDay(value) {
      this.timeValue = value;
      if (this.powerArray.length != 0) {
        this.powerArray = [];
      }
    },
    numUnit(value) {
      if (value) {
        if (this.timeValue != "day") {
          return (value / 1000).toFixed(2);
        } else {
          return value;
        }
      }
    },
    getNum() {
      this.powerData.map((item, index) => {
        item.num = this.percent?.[this.timeValue]?.[item.key]?.percent;
        if (
          this.percent?.[this.timeValue]?.[item.key]?.value >= 100000 ||
          this.timeValue != "day"
        ) {
          item.unit =
            (this.percent?.[this.timeValue]?.[item.key]?.value / 1000).toFixed(
              2
            ) + "mWh";
        } else {
          item.unit = this.percent?.[this.timeValue]?.[item.key]?.value + "kWh";
        }
      });
    },
    loadOptions() {
      let colorList = [
        "#22FCD5",
        "rgba(0,0,0,0)",
        "#2D82FF",
        "rgba(0,0,0,0)",
        "#FFB0AB",
        "rgba(0,0,0,0)",
        "#B98EFF",
        "rgba(0,0,0,0)",
      ];

      let radius = 445;
      let distance = 20;

      let all = this.percent[this.timeValue]?.total;
      let a = distance / radius;
      let value = (all * a) / 4;
      let powerMap = ["lighting", "power", "air", "other"];
      let eleNameMap = {
        lighting: "照明电",
        power: "动力电",
        air: "空调电",
        other: "其他",
      };
      for (let item = 0; item < powerMap.length; item++) {
        this.powerArray.push({
          value: this.percent?.[this.timeValue]?.[powerMap[item]]?.value,
          name: eleNameMap[powerMap[item]],
        });
        this.powerArray.push({
          value: value,
          name: "",
        });
      }
      this.options = {
        color: colorList,
        tooltip: {
          show: false,
          trigger: "item",
        },
        series: [
          {
            type: "pie",
            radius: ["78%", "92%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 25,
              borderWidth: 5,
            },
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: false,
                fontSize: "40",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },

            data: this.powerArray,
          },
        ],
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.ele-content {
  margin: 20px;
  height: 154px;
  display: flex;
  .left-chart {
    width: 142px;
    height: 142px;
    position: relative;
    .chart-name {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      .num {
        font-style: normal;
        font-weight: 500;
        font-size: 36px;
        line-height: 41px;
        font-family: "dina";
      }
      .text {
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 27px;
      }
    }
  }
  .right-per {
    margin-left: 20px;
    .per-item {
      display: flex;
      align-items: center;
      height: 31px;
      padding: 5px 8px;
      background: rgba(0, 0, 0, 0.2);
      margin-bottom: 10px;
      .icon {
        width: 10px;
        height: 10px;
        border-radius: 2px;
      }
      .icon1 {
        background: #22fcd5;
      }
      .icon2 {
        background: #2d82ff;
      }
      .icon3 {
        background: #ffb0ab;
      }
      .icon4 {
        background: #b98eff;
      }
      .per-num {
        margin-left: 8px;
        width: 33px;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 21px;
        color: #ffffff;
        font-family: "dina";
      }
      .per-name {
        margin-left: 8px;
        width: 45px;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;
      }
      .per-line {
        margin-left: 4px;
        width: 1px;
        height: 18px;
        background: rgba(217, 217, 217, 0.1);
      }
      .per-unit {
        margin-left: 4px;
        width: 80px;
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        line-height: 21px;
        text-align: right;
      }
    }
  }
}
</style>
